import React from 'react'
import { Link } from 'react-router-dom'
import { FaRegUserCircle } from 'react-icons/fa';
import { AiTwotoneTag } from 'react-icons/ai'
import { BiPhoneCall } from 'react-icons/bi'

function ContactNav() {
  return (
  <>
  <div className="nav--contain">

  <div className='nav-head'>
      <div className='logo--container2'>
        <div className='logo2'>
          <h3 className='logo--text2'>
            BPC
          </h3>
        </div>

        <p className='logo--small-text2'>
          Design Studio
        </p>
      </div>

      <nav className='middle--nav2'>
        <Link to='/' className='links2'>Home</Link>
        <Link to='/work' className='links2'>Our Work</Link>
        <Link to='/services' className='links2'>Services</Link>
        <Link to='/packages' className='links2'>Packages</Link>
        <Link to='/contact' className='links2'>Contact</Link>

      </nav>

      <nav className='right--nav2'>
        <div className='sign--btn2'>
          <FaRegUserCircle className='user--icon2' /> <Link to='/contact' className='sign--link2'>Sign In</Link>
        </div>
        <div className='price--btn'>
          <AiTwotoneTag className='price--icon2' /><Link to='/packages' className='price--link2'>Pricing</Link>
        </div>
      </nav>

    </div>

    <div className="contact-text">
    <BiPhoneCall className='call-icon'/><h1 className='contact'>Contact Us</h1>
    </div>
    <h3 className='number'>09129639239</h3>
  </div>
  </>
  )
}

export default ContactNav